import React, { useState, useContext, useEffect } from 'react';
import { DATA_CONFIGURATION, ADD_EDIT_RESPONSE_MESSAGES, LEAVE_UPLOAD } from '../../../Constants/strings';
import { MODULE_NAMES } from '../../../Constants/modules';
import dayjs from 'dayjs';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import { AuthContext } from '../../../Contexts/AuthContext';
import UseAxios from '../../../Api/http/http';
import { fetchConfigUploadDates, updateConfigUploadDates } from '../../../Api/request/configDataUploadDates';
import { STATUS_CODES } from '../../../Api/resources/statusCodes';
import DataUploadConfig from '../../../Components/DataUploadConfig/dataUploadConfig';

const LeaveUploadConfig = () => {
  const [startDateInput, setStartDateInput] = useState('');
  const [endDateInput, setEndDateInput] = useState('');
  const [startDateError, setStartDateError] = useState('');
  const [endDateError, setEndDateError] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const { snackbarOpen } = useSnackbar();
  const { userProfile } = useContext(AuthContext);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.CONFIGURATION_DATE_CONFIG] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const handleEdit = () => {
    setIsEdit(true);
  };

  const fetchConfigLeaveUploadDates = async () => {
    try {
      const uploadCategory = 'leave-details';
      const response = await UseAxios(fetchConfigUploadDates(uploadCategory));
      if (response.data?.response?.data?.statusCode === STATUS_CODES.NO_DATA) {
        console.log('No config Data');
      } else {
        const configDates = response.data.dataUploadConfig[0];
        setStartDateInput(configDates.startDate);
        setEndDateInput(configDates.endDate);
        setIsChecked(configDates.isFutureEligibility);
      }
    } catch (error) {
      snackbarOpen(LEAVE_UPLOAD.OOPS_TRY_AGAIN, 'warning');
      console.error('Error fetching config effort upload dates:', error);
    }
  };

  useEffect(() => {
    fetchConfigLeaveUploadDates();
  }, []);

  const handleSetButton = () => {
    try {

      if (startDateError || endDateError) return;

      const requestData = {
        startDate: startDateInput,
        endDate: endDateInput,
        isFutureEligibility: isChecked,
        lastUpdatedBy: userProfile?.user_name,
        uploadCategory: 'leave-details',
      };

      if (!handleValidateFields(requestData)) return;
      UseAxios(updateConfigUploadDates(requestData));
      setIsEdit(false);
      snackbarOpen(DATA_CONFIGURATION.LEAVE_UPLOAD_ADD_SUCCESS,
        'success',
      );
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleValidateFields = (reqData) => {
    let isValid = true;

    if (!reqData.startDate) {
      setStartDateError(ADD_EDIT_RESPONSE_MESSAGES.ENTER_START_DATE);
      isValid = false;
    } else {
      setStartDateError('');
    }

    if (!reqData.endDate) {
      setEndDateError(ADD_EDIT_RESPONSE_MESSAGES.ENTER_END_DATE);
      isValid = false;
    } else {
      setEndDateError('');
    }

    return isValid;
  };

  const handleCheckBoxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleStartDate = ({ value }) => {
    const formattedDate = dayjs(value).isValid()
      ? dayjs(value).format('YYYY-MM-DD')
      : '';
    setStartDateInput(formattedDate);

    // Validate start date
    let startDateErrorMessage = '';
    const endDateErrorMessage = '';

    if (!formattedDate) {
      startDateErrorMessage = ADD_EDIT_RESPONSE_MESSAGES.ENTER_START_DATE;
    } else if (
      endDateInput && new Date(formattedDate) >= new Date(endDateInput)
    ) {
      startDateErrorMessage = ADD_EDIT_RESPONSE_MESSAGES.START_DATE_LESS_THAN_END_DATE;
    } else {
      setStartDateError('');
      setEndDateError('');
    }
    setStartDateError(startDateErrorMessage);
    setEndDateError(endDateErrorMessage);
  };

  const handleEndDate = ({ value }) => {
    const formattedDate = dayjs(value).isValid()
      ? dayjs(value).format('YYYY-MM-DD')
      : '';
    setEndDateInput(formattedDate);

    // Validate end date
    let endDateErrorMessage = '';
    const startDateErrorMessage = '';

    if (!formattedDate) {
      endDateErrorMessage = ADD_EDIT_RESPONSE_MESSAGES.ENTER_END_DATE;
    } else if (
      startDateInput && new Date(formattedDate) <= new Date(startDateInput)
    ) {
      endDateErrorMessage = ADD_EDIT_RESPONSE_MESSAGES.START_DATE_LESS_THAN_END_DATE;
    } else {
      setStartDateError('');
      setEndDateError('');
    }
    setEndDateError(endDateErrorMessage);
    setStartDateError(startDateErrorMessage);
  };

  return (
    <DataUploadConfig
      header={DATA_CONFIGURATION.LEAVE_UPLOAD}
      isEdit={isEdit}
      startDateInput={startDateInput}
      endDateInput={endDateInput}
      startDateError={startDateError}
      endDateError={endDateError}
      isChecked={isChecked}
      hasAccess={hasAccess}
      handleEdit={handleEdit}
      handleSetButton={handleSetButton}
      handleStartDate={handleStartDate}
      handleEndDate={handleEndDate}
      handleCheckBoxChange={handleCheckBoxChange}
      btnId='leave-upload-set-button'
    />
  );
};

export default LeaveUploadConfig;
